import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Card, Skeleton, Badge, Empty } from "@/components/ui";
import type { Appointment } from "@/types";

export default function Appointments() {
  const q = useQuery({
    queryKey: ["appointments-all"],
    queryFn: () => api.get<Appointment[]>("/appointments?limit=500"),
  });
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-semibold text-slate-50">Appointments & tests</h1>
        <div className="text-sm text-slate-400">All scheduled / pending visits and investigations.</div>
      </div>
      {q.isLoading ? <Card><Skeleton /></Card> :
       !q.data || q.data.length === 0 ? <Empty title="No appointments." /> :
       <Card>
         <table className="table">
           <thead><tr><th>When</th><th>Title</th><th>Kind</th><th>Status</th><th>Location</th></tr></thead>
           <tbody>
             {q.data.map((a) => (
               <tr key={a.id}>
                 <td className="text-xs text-slate-500">{a.scheduled_for ? new Date(a.scheduled_for).toLocaleString() : "—"}</td>
                 <td>{a.title}</td>
                 <td><Badge tone="muted">{a.kind}</Badge></td>
                 <td><Badge tone={a.status === "scheduled" ? "ok" : a.status === "missed" ? "bad" : "warn"}>{a.status}</Badge></td>
                 <td className="text-slate-400">{a.location || "—"}</td>
               </tr>
             ))}
           </tbody>
         </table>
       </Card>}
    </div>
  );
}
